import styled, { css } from "styled-components";
import Spring from "../../components/Spring";

export const StyledSpring = styled(Spring)`
    margin-top: 50px;
    background-color: ${p => p.theme.c.snow};
`;

export const Flex = styled.div`
    display: flex;
    ${p =>
        p.theme.lg(css`
            margin: 0 150px;
        `)}
    ${p =>
        p.theme.md.only(css`
            margin: 0 46px;
        `)}
`;

export const Column = styled.div`
    padding: 16px;
    flex: 1;
`;

export const Desktop = styled.div`
    display: flex;
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
`;

export const Mobile = styled.div`
    hr {
        display: none;
    }
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}
`;
